import React from "react";
import KeyType from "./keyboardKeyType";
import * as Misc from "./../../misc";
import Analytics from './../../analytics';

export default class KeyboardKey extends React.PureComponent {
  handleClick = (e) => {
    Misc.ignoreDefault(e);
    let key = this.props.keyValue;
    if (!this.props.raw && this.props.isUpperCase && this.props.keyValue2) {
      key = this.props.keyValue2;
    }
    Analytics.sendClickEvent('osk-keyboard-key');

    this.props.runKeyStroke(key);
  };

  render() {
    let enabled = true;
    if (this.props.isUpperCase) {
      if (!this.props.keyValue2) {
        enabled = false;
      }
    }

    let key = this.props.keyValue;
    switch (key) {
      case 'backspace':
      case "|<":
      case "|>":
        key = '';
        break;
      default:
        if (this.props.isUpperCase) {
          if (this.props.keyValue2) {
            key = this.props.keyValue2;
          } else if (this.props.type === KeyType.Types.RIGHT_PANEL) {
            key = key.toUpperCase();
          }
        }
        break;
    }

    let className = KeyType.className(this.props.type);
    if (this.props.type === KeyType.Types.NORMAL) {
      if (!enabled) {
        className += " keyboard-keys-shifted-enabled";
      } else if (this.props.isUpperCase) {
        className += " keyboard-keys-shifted";
      }

      if (this.props.keyValue === 'backspace') {
        className += " keyboard-backspace-key";
      }
    }

    switch (this.props.type) {
      case KeyType.Types.NUMERIC:
      case KeyType.Types.NUMERIC_EXTENDED:
        return (
          <div className={className} onClick={this.handleClick}>{key}</div>
        );
      case KeyType.Types.RIGHT_PANEL:
        return (<div className={className} onClick={this.handleClick}>{key}</div>);
      default:
        let img = null;
        if (this.props.image) {
          img = (<img src={this.props.image}/>);
        }
        return (<div className={className} onClick={this.handleClick}><h1>{this.props.keyValue2}</h1><h2>{key}</h2>{img}
        </div>);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/OnScreenKeyboard/keyboardKey.js